


















import Vue from 'vue';

import { Dialog } from '@/services/UI';

import DialogBase from '@/dialogs/DialogBase.vue';

import Workspace from '@/models/soukai/Workspace';

export default Vue.extend({
    components: {
        DialogBase,
    },
    props: {
        dialog: {
            type: Object as () => Dialog,
            required: true,
        },
        workspace: {
            type: Object as () => Workspace,
            required: true,
        },
    },
    methods: {
        async confirm() {
            await this.$ui.wrapAsyncOperation(this.removeWorkspace());

            this.$ui.completeDialog(this.dialog.id);
        },
        cancel() {
            this.$ui.completeDialog(this.dialog.id);
        },
        async removeWorkspace() {
            await this.workspace.delete();

            this.$workspaces.remove(this.workspace);
        },
    },
});
